import { useState, useEffect } from 'react';
import { getCandidateHarvestBots, IHarvestBot } from 'wisestep-api';

const useGetCandidateHarvestBots = (
  jobBoard: string,
  status: string,
  pageNumber: number,
  allBots: boolean
): [IHarvestBot[], number] => {
  const [harvestBots, setHarvestBots] = useState<IHarvestBot[]>([]);
  const [totalCount, setTotalCount] = useState<number>(0);
  useEffect(() => {
    const getHarvestBotEvent = async () => {
      const response = await getCandidateHarvestBots(jobBoard, status, allBots, pageNumber);
      setHarvestBots(response?.data);
      setTotalCount(parseInt(response.headers['x-total-count']));
    };
    getHarvestBotEvent();
  }, [allBots, status, pageNumber, jobBoard]);
  return [harvestBots, totalCount];
};

export default useGetCandidateHarvestBots;
